exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thead-color {\n    background: #005296;\n    color: #fff;\n}\n", ""]);

// exports
